import { Tabs } from "@shopify/polaris"
import classnames from "classnames"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"

import { ThemeLayoutEnum } from "@/models/ITrackingPageOptions"

import styles from "./index.module.scss"
import { THEME_LAYOUT_LEFT_ROOT_ID } from "./themeLayoutLeftScroll"
import {
  ThemeLayoutLeftContentTabPanel,
  ThemeLayoutLeftStyleTabPanel,
} from "./ThemeLayoutLeftTabPanels"

export interface ThemeLayoutLeftLayoutProps {
  variant: ThemeLayoutEnum
}

/**
 * 左侧编辑区（结构对齐 Email Edit 的 LeftLayout：顶部 Tabs + 面板内容）。
 */
const LeftLayout = ({ variant }: ThemeLayoutLeftLayoutProps) => {
  const { t } = useTranslation("tracking_page")
  const [selected, setSelected] = useState(0)

  const tabs = [
    {
      accessibilityLabel: t("themeLayoutEditorLeftTabContent"),
      children: <ThemeLayoutLeftContentTabPanel variant={variant} />,
      content: t("themeLayoutEditorLeftTabContent"),
      id: "theme-layout-left-content",
    },
    {
      accessibilityLabel: t("themeLayoutEditorLeftTabStyle"),
      children: <ThemeLayoutLeftStyleTabPanel variant={variant} />,
      content: t("themeLayoutEditorLeftTabStyle"),
      id: "theme-layout-left-style",
    },
  ]

  return (
    <div
      id={THEME_LAYOUT_LEFT_ROOT_ID}
      className="relative flex min-h-0 w-full min-w-0 flex-1 flex-col"
    >
      <div className={styles.tabContainer}>
        <Tabs fitted selected={selected} tabs={tabs} onSelect={setSelected} />
      </div>
      <div
        className={classnames(
          "box-border min-h-0 flex-1 overflow-y-auto",
          styles.cardContainer,
        )}
      >
        {tabs[selected].children}
      </div>
    </div>
  )
}

export default LeftLayout
